/* AVAHEL - Product page block interactions */
(function(){
  function pad(n){ return n < 10 ? '0' + n : String(n); }

  // Countdown timer
  document.querySelectorAll('.pk-cd').forEach(function(block){
    var endStr = block.dataset.end;
    if (!endStr) return;
    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;
    var active = block.querySelector('[data-when="active"]');
    var ended = block.querySelector('[data-when="ended"]');
    var units = {
      days: block.querySelector('[data-unit="days"]'),
      hours: block.querySelector('[data-unit="hours"]'),
      minutes: block.querySelector('[data-unit="minutes"]'),
      seconds: block.querySelector('[data-unit="seconds"]')
    };
    function tick(){
      var diff = endTime - Date.now();
      if (diff <= 0) {
        if (active) active.hidden = true;
        if (ended) ended.hidden = false;
        clearInterval(t);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      if (units.days) units.days.textContent = pad(d);
      if (units.hours) units.hours.textContent = pad(h);
      if (units.minutes) units.minutes.textContent = pad(m);
      if (units.seconds) units.seconds.textContent = pad(s);
    }
    tick();
    var t = setInterval(tick, 1000);
  });

  // Live viewers - random count that fluctuates
  document.querySelectorAll('.pk-vw').forEach(function(block){
    var min = parseInt(block.dataset.min, 10) || 8;
    var max = parseInt(block.dataset.max, 10) || 24;
    var counter = block.querySelector('[data-count]');
    if (!counter) return;
    function randCount(){ return Math.floor(Math.random() * (max - min + 1)) + min; }
    counter.textContent = randCount();
    // Fluctuate every 8-15s
    setInterval(function(){ counter.textContent = randCount(); }, 8000 + Math.random() * 7000);
  });

  // Delivery estimate - calculate order-within time + delivery date
  document.querySelectorAll('.pk-dl').forEach(function(block){
    var cutoffHour = parseInt(block.dataset.cutoffHour, 10);
    var deliveryDays = parseInt(block.dataset.days, 10);
    var timeEl = block.querySelector('[data-time]');
    var dateEl = block.querySelector('[data-date]');
    if (isNaN(cutoffHour) || isNaN(deliveryDays)) return;

    function update(){
      var now = new Date();
      var cutoff = new Date();
      cutoff.setHours(cutoffHour, 0, 0, 0);
      var passed = now > cutoff;
      // If passed cutoff, delivery calculation starts from tomorrow's cutoff
      if (passed) cutoff.setDate(cutoff.getDate() + 1);
      var diff = cutoff - now;
      if (diff > 0 && !passed) {
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        if (timeEl) timeEl.textContent = h + 'h ' + m + 'm';
      } else {
        if (timeEl) timeEl.textContent = 'tomorrow';
      }
      // Delivery date
      var deliveryDate = new Date(cutoff);
      deliveryDate.setDate(deliveryDate.getDate() + deliveryDays);
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      if (dateEl) dateEl.textContent = days[deliveryDate.getDay()] + ', ' + months[deliveryDate.getMonth()] + ' ' + deliveryDate.getDate();
    }
    update();
    setInterval(update, 60000); // Update every minute
  });
})();
